import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQueryV1 } from './baseQueryV1';

export const bankDetailsApi = createApi({
  reducerPath: 'bankDetailsApi',
  baseQuery: baseQueryV1,
  tagTypes: ['BankDetails'],
  endpoints: (builder) => ({
    getBankDetails: builder.query({
      query: () => 'bank-details',
      transformResponse: (res) => res.data,
      providesTags: ['BankDetails'],
    }),
    getBankDetailByUserId: builder.query({
      query: (id) => ({
        url: `bank-details/user/${id}`,
        method: 'GET',
      }),
      transformResponse: (res) => res.data,
      providesTags: ['BankDetails'],
    }),
    getPrimaryBankDetailByUserId: builder.query({
      query: (id) => ({
        url: `bank-details/user/${id}/primary`,
        method: 'GET',
      }),
      transformResponse: (res) => res.data,
      providesTags: ['BankDetails'],
    }),
    addBankDetail: builder.mutation({
      query: (bankDetail) => ({
        url: 'bank-details',
        method: 'POST',
        body: bankDetail,
      }),
      transformResponse: (res) => res.data,
      invalidatesTags: ['BankDetails'],
    }),
    updateBankDetail: builder.mutation({
      query: ({ id, ...bankDetail }) => ({
        url: `bank-details/${id}`,
        method: 'PUT',
        body: bankDetail,
      }),
      transformResponse: (res) => res.data,
      invalidatesTags: ['BankDetails'],
    }),
    deleteBankDetail: builder.mutation({
      query: ({ id }) => ({
        url: `bank-details/${id}`,
        method: 'DELETE',
      }),
      transformResponse: (res) => res.data,
      invalidatesTags: ['BankDetails'],
    }),
    setAsPrimaryBankDetail: builder.mutation({
      query: ({ id, bankDetailId }) => ({
        url: `bank-details/user/${id}/primary/${bankDetailId}`,
        method: 'PUT',
      }),
      transformResponse: (res) => res.data,
      invalidatesTags: ['BankDetails'],
    }),
  }),
});

export const {
  useSetAsPrimaryBankDetailMutation,
  useGetBankDetailsQuery,
  useGetBankDetailByUserIdQuery,
  useGetPrimaryBankDetailByUserIdQuery,
  useAddBankDetailMutation,
  useUpdateBankDetailMutation,
  useDeleteBankDetailMutation,
} = bankDetailsApi;
